<template>
  <div class="home">
      <VideoAdmin class="marginal" ></VideoAdmin>
  </div>
</template>

<script>
import VideoAdmin from '@/components/VideoAdmin.vue';
export default {
  name: 'videoadmin',
  components: {
    VideoAdmin
  }
}
</script>